'use client';

import { use } from 'react';

import LandingCollectionItem, {
  LandingCollectionProps,
} from '../LandingCollectionItem/LandingCollectionItem';

import Container from './parts/Container';

interface RecommendedCollectionsProps {
  collectionsPromise: Promise<LandingCollectionProps[]>;
}

const RecommendedCollections = ({
  collectionsPromise,
}: RecommendedCollectionsProps) => {
  const collections = use(collectionsPromise);

  return (
    <Container data-testid="landing-recommended-collection-list">
      {collections.map((collection) => (
        <LandingCollectionItem
          key={collection.id}
          useScrapButton
          {...collection}
        />
      ))}
    </Container>
  );
};

export default RecommendedCollections;
